import { Outlet } from "react-router-dom";

/** Renders child routes under `/en` or `/es`. */
export function LocaleBranch() {
  return <Outlet />;
}
